<template >
    <transition name="fade" mode="out-in">
        <div>
            <ul class="submenu-sections">
                <router-link tag="li" :to="{name:'PlanningDetails', params:$route.params}">
                    <a><h4><span class="text">Tracks</span></h4></a>
                </router-link>
                <router-link tag="li" :to="{name:'PlanningPodcasts', params:$route.params}">
                    <a><h4><span class="text">Podcasts</span></h4></a>
                </router-link>
                <router-link tag="li" :to="{name:'PlanningLogs', params:$route.params}">
                    <a><h4><span class="text">Logs</span></h4></a>
                </router-link>
                <router-link tag="li" :to="{name:'PlanningStats', params:$route.params}">
                    <a><h4><span class="text">Stats</span></h4></a>
                </router-link>
            </ul>
        </div>
    </transition>
</template>

<script>
    import Vue from 'vue';
    import { mapState, mapActions } from 'vuex'
    import store from '@/store/index.js'
    import Translations from '@/store/translations';

    export default {
        name: "PlanningMenu",
        store,
        components: {
        },
        computed: {
            Translations: () => Translations,
            // keep it for redirect links
            params: function() { return this.$route.params; },
        },
    }
</script>

<style scoped>
</style>